import { baseApiUrl } from "../environment/values";
import { axiosInstance as axios } from "../main";
import helpers from "../helpers/helpers";
import queryString from "query-string";

const state = {
  requests: [],
  currentDetail: null,
  detailStatus: "idle",
  totalRequests: null,
  requestStatus: "idle",
  statusOptions: [],
};

const getters = {
  requestSuccess: (state) => state.requestStatus === "success",
  requestLoading: (state) => state.requestStatus === "loading",
  requestError: (state) => state.requestStatus === "error",

  detailSuccess: (state) => state.detailStatus === "success",
  detailLoading: (state) => state.detailStatus === "loading",
  detailError: (state) => state.detailStatus === "error",
};

const actions = {
  async getAllRequests({ commit }, { pagination } = {}) {
    if (!pagination) return;

    const { page, search, status, itemsPerPage: rowsPerPage } = pagination;

    const statusQuery = helpers.generatePaginationQuery("status_id", status);

    const queryParams = {
      ...helpers.createQueryParam("page", page),
      ...helpers.createQueryParam("page_size", rowsPerPage),
      ...helpers.createQueryParam("search", search),
    };

    if (statusQuery) {
      Object.assign(queryParams, queryString.parse(statusQuery));
    }

    const query = queryString.stringify(queryParams);
    const url = `${baseApiUrl}technician_request/?${query}`;

    try {
      commit("setRequestStatus", "loading");
      const { data } = await axios.get(url);
      const formattedRequests = formatRequests(data.results);
      commit("setRequests", formattedRequests);
      commit("setTotalRequests", data.count);
      commit("setStatusOptions", data.filters);
      commit("setRequestStatus", "success");
    } catch (error) {
      commit("setRequestStatus", "error");
      console.error(error);
    } finally {
      commit("setRequestStatus", "idle");
    }
  },
  async getRequestById({ commit, state }, id) {
    if (!id) return;

    const url = `${baseApiUrl}technician_request_detail/${id}/`;

    try {
      commit("setDetailStatus", "loading");
      const { data } = await axios.get(url);
      commit("setCurrentDetail", data);
      commit("setDetailStatus", "success");
      return data;
    } catch (error) {
      commit("setDetailStatus", "error");
      console.error(error);
      throw error;
    } finally {
      commit("setDetailStatus", "idle");
    }
  },
};

const mutations = {
  setRequests: (state, payload) => (state.requests = payload),
  setCurrentDetail: (state, payload) => (state.currentDetail = payload),
  setRequestStatus: (state, payload) => (state.requestStatus = payload),
  setTotalRequests: (state, payload) => (state.totalRequests = payload),
  setStatusOptions: (state, payload) => (state.statusOptions = payload),
  setDetailStatus: (state, payload) => (state.detailStatus = payload),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

function formatRequests(requests) {
  return requests.map((request) => {
    let displayExternalID;

    if (request.external_id != null) {
      displayExternalID = `(${request.external_id})`;
    }

    return {
      address: request.address,
      city: request.city,
      client: request.client,
      display_id: displayExternalID,
      external_id: request.external_id,
      id: request.id,
      is_urgency: request.is_urgency,
      status: request.status,
      status_id: request.status_id,
      rubro: request.rubro,
      service: request.service,
      scheme: request.scheme,
    };
  });
}
